export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7f43a24806af5eef5f330f1cdead54caf3d1e57aa9&name=fetchTypeahead!'